import React from "react"
import Text from "../Text"
import styled from "styled-components"
import * as colors from "../../assets/_base/colors"

const Wrapper = styled.div`
    margin-top: 5px;
    margin-bottom: 5px;
`
const Label = styled(Text)`
    font-size: 16px;
    margin-bottom: 2px;
`


const Select = styled.select`
    font-family: Titillium Web;
    width: 100%;
    height: 100%;
    border: none;
    padding: 20px;
    background-color: ${colors.lightBlue};
    padding-left: 20px;
    padding-right: 20px;
    
    color: white;
    outline: none;
    cursor: pointer;
    padding: 8px;
    font-size: 16px;
    border-round: 4px;
    font-size: 18px;
    border-radius: 10px;

    :focus {
        background-color: ${colors.darkBlue};
    }

`
const Option = styled.option`
    font-family: Titillium Web;
    background-color: ${colors.lightBlue};
    cursor: pointer ;
    font-size: 16px;
    top: 20;

    :hover{
        background-color: ${colors.dark};
        padding: 20px;
    }
    :checked{
        background-color: ${colors.lightBlue};
        color: ${colors.lightBlue2};
        font-weight: bold;
    }
`

export default props => {
    const SELECT_ID = React.useMemo(() => `select-${Math.random().toString(36).substr(2, 9)}`, [])
    const [options, setOptions] = React.useState([])
    const ref = React.useRef(null)

    function init() {
        if (ref.current) {
            if (props.options) {
                setOptions(props.options)
            }
        }
    }

    React.useEffect(init, [props.options])

    function onChange(e) {
        try {
            const currentOptions = document.getElementById(SELECT_ID).options
            for (let option of currentOptions) {
                option.innerHTML = option.innerText.replace("✅", "")
                if (option.selected) {
                    option.innerHTML = `${option.innerText} <small>✅</small>`
                }
            }
            if (props.onChange) {
                props.onChange(options.filter(item => item.value == e.target.value)[0])
            }
        } catch (error) { }
    }

    return <Wrapper ref={ref}>
        <Label>
            {
                props.label
            }
        </Label>
        <Select
            {...props}
            id={SELECT_ID}
            onChange={onChange}>
            {
                options.map((option, index) => {
                    if (props.defaultIndexSelected == index) {
                        option.label = `${option.label} ✅`
                    }
                    return <Option
                        value={option.value}
                        selected={props.defaultIndexSelected == index}
                        key={`custom-select-key-${index}`}>
                        {option.label}
                    </Option>
                })
            }
        </Select>
    </Wrapper>
}
"hello 3 "


// WEBPACK FOOTER //
// ./src/_components/Select/index.jsx